export default {
  common: { continue: 'Continua', back: 'Enrere', skip: 'Salta', save: 'Desa', cancel: 'Cancel·la', loading: 'Carregant…', error: 'Alguna cosa ha fallat. Torna-ho a provar.', required: 'Camp obligatori', brandName: 'ininvoice', copyright: '© 2026 ININVOICE. Tots els drets reservats.' },
  brand: { name: 'ininvoice', tagline: 'Paga només el que vas demanar i has rebut.' },
  auth: {
    login: { title: 'Inicia sessió', email: 'Email', password: 'Contrasenya', submit: 'Entra', forgot: 'Has oblidat la contrasenya?', noAccount: 'No tens compte?', createAccount: 'Crear compte', googleSignIn: 'Continua amb Google', or: 'o' },
    forgot: { title: 'Recuperar contrasenya', hint: 'T’enviem un enllaç per restablir-la.', submit: 'Envia l’enllaç', backToLogin: 'Torna a l’inici de sessió', sent: 'Email enviat. Revisa la safata.' },
    reset: { title: 'Nova contrasenya', newPassword: 'Nova contrasenya', confirmPassword: 'Confirma la contrasenya', submit: 'Desa la contrasenya', success: 'Contrasenya actualitzada. Torna a entrar.', mismatch: 'Les contrasenyes no coincideixen' },
    callback: { processing: 'Iniciant sessió…' },
  },
  invitation: {
    heading: "T'han convidat",
    headingSignIn: "Entra per acceptar la invitació",
    title: "Invitació a {org}",
    by: "{who} et convida a aprovar factures de {org} a ininvoice. Crea el teu compte amb aquest correu o entra si ja el tens.",
    anonymous: "Et conviden a aprovar factures de {org} a ininvoice. Crea el teu compte amb aquest correu o entra si ja el tens.",
    emailLocked: "La invitació és per a aquest correu.",
    dead: "Aquesta invitació no existeix, ja s'ha fet servir o s'ha retirat. Demana'n una de nova a qui et va convidar.",
  },
  signupHero: {
    email: 'El teu email de feina',
    submit: 'Continua',
    haveAccount: 'Ja tens compte?',
    signIn: 'Inicia sessió',
    emailRequired: "L'email és obligatori",
    emailInvalid: 'Email no vàlid',
  },
  requestAccess: {
    title: 'Sol·licita accés',
    body: 'ininvoice funciona per invitació. Si algú de la teva empresa ja el fa servir, demana-li que et convidi; si no, explica’ns què necessites i et donem accés.',
    cta: 'Sol·licitar accés',
    haveAccount: 'Ja tens compte?',
    signIn: 'Inicia sessió',
  },
  signin: {
    title: 'Benvingut a ininvoice',
    google: 'Continua amb Google',
    googleLoading: 'Connectant…',
    or: 'o',
    email: 'Email',
    password: 'Contrasenya',
    forgot: 'Has oblidat la contrasenya?',
    submit: 'Inicia sessió',
    noAccess: 'La teva empresa encara no fa servir ininvoice?',
    requestAccess: 'Sol·licitar accés',
    invited: 'És la primera vegada amb aquesta invitació?',
    createAccount: 'Crea el teu compte',
    emailRequired: "L'email és obligatori",
    emailInvalid: 'Email no vàlid',
    passwordRequired: 'La contrasenya és obligatòria',
    errors: {
      credentials: 'Email o contrasenya incorrectes. Si entres amb Google, fes servir «Continua amb Google».',
      tooMany: 'Massa intents. Espera uns minuts i torna-ho a provar.',
      tooManySeconds: 'Massa intents. Torna-ho a provar d’aquí a {seconds} s.',
      captcha: 'La verificació de seguretat no és vàlida o ha caducat. Repeteix-la i torna-ho a provar.',
      generic: 'No hem pogut iniciar la sessió. Torna-ho a provar en uns segons.',
    },
  },
  signup: {
    title: 'Crea el teu compte',
    subtitle: 'Comença en minuts.',
    email: 'Email d’empresa',
    password: 'Contrasenya',
    passwordHint: 'Mínim 8 caràcters, una majúscula i un número.',
    accept: 'Accepto les {terms} i la {privacy}.',
    termsLink: 'condicions del servei',
    privacyLink: 'política de privacitat',
    submit: 'Crear compte',
    haveAccount: 'Ja tens compte?',
    signIn: 'Inicia sessió',
    rules: {
      emailRequired: "L'email és obligatori",
      emailInvalid: 'Email no vàlid',
      passwordRequired: 'La contrasenya és obligatòria',
      passwordMin: 'Mínim 8 caràcters',
      passwordUpper: 'Ha de contenir almenys una majúscula',
      passwordDigit: 'Ha de contenir almenys un número',
      mustAccept: 'Accepta les condicions per continuar',
    },
    errors: {
      alreadyHaveAccount: 'Si ja tens compte, entra amb el teu email i contrasenya.',
      passwordWeak: 'La contrasenya no compleix els requisits',
      captcha: 'La verificació de seguretat no és vàlida o ha caducat. Repeteix-la i torna-ho a provar.',
      tooMany: 'Massa intents. Espera uns minuts i torna-ho a provar.',
      session: 'El compte està creat, però no hem pogut iniciar la sessió. Entra amb el teu email i contrasenya.',
      generic: 'No hem pogut crear el compte. Torna-ho a provar en uns segons.',
    },
  },
  forgot: {
    title: 'Recupera la contrasenya',
    hint: 'Escriu el teu email i t’enviarem un enllaç per triar-ne una de nova.',
    email: 'Email',
    submit: 'Envia l’enllaç',
    sentTitle: 'Revisa el correu',
    sentBody: 'Si hi ha un compte amb {email}, d’aquí a uns minuts t’arribarà un enllaç per restablir la contrasenya.',
    backToSignIn: 'Torna a iniciar sessió',
    emailRequired: "L'email és obligatori",
    emailInvalid: 'Email no vàlid',
    errors: {
      tooMany: 'Massa sol·licituds. Espera uns minuts i torna-ho a provar.',
      tooManySeconds: 'Massa sol·licituds. Torna-ho a provar d’aquí a {seconds} s.',
      captcha: 'La verificació de seguretat no és vàlida o ha caducat. Repeteix-la i torna-ho a provar.',
    },
  },
  turnstile: {
    failed: 'No hem pogut carregar la verificació de seguretat. Recarrega la pàgina.',
  },
  qualify: {
    title: 'Configura el teu compte',
    subtitle: 'Adaptem l’app al teu cas. 30 segons.',
    progress: 'Pas {current} de {total}',
    next: 'Continua', back: 'Enrere', skip: 'Salta', finish: 'Entra a l’app',
    error: 'No s’ha pogut desar. Reintentant…',
    steps: {
      role:        { title: 'Quin és el teu rol?', hint: 'Ho fem servir per mostrar-te primer el que importa.' },
      companySize: { title: 'Quantes persones sou?', hint: 'Empleats totals, no només l’equip de finances.' },
      volume:      { title: 'Quantes factures rebeu al mes?', hint: 'Aproximat. Serveix per ajustar el pla.' },
      erp:         { title: 'Què feu servir per a la comptabilitat?', hint: 'Marca tot el que apliqui. Si no en feu servir cap, marca Excel.' },
      pain:        { title: 'Què et porta aquí?', hint: 'Només la principal. La resta, després.' },
      callback:    { title: 'Prefereixo que em truqueu', hint: 'Et truquem avui si ho necessites.', phoneLabel: 'Telèfon', wantsCall: 'Vull que em truqueu per veure-ho en directe' },
    },
    options: {
      role: { cfo: 'Director financer / CFO', ap_manager: 'Responsable de comptes a pagar', controller: 'Controller / Cap administració', founder_ceo: 'Fundador / CEO', accountant_asesoria: 'Assessoria / Despatx comptable', bookkeeper: 'Comptable intern', other: 'Altres' },
      companySize: { '1-9': '1-9 empleats', '10-49': '10-49 empleats', '50-249': '50-249 empleats', '250+': '250+ empleats' },
      volume: { lt_50: 'Menys de 50 factures/mes', '50_150': '50-150 factures/mes', '150_300': '150-300 factures/mes', '300_1000': '300-1.000 factures/mes', '1000_plus': 'Més de 1.000 factures/mes' },
      erp: { holded: 'Holded', quickbooks: 'QuickBooks', xero: 'Xero', sage50: 'Sage 50', sage200: 'Sage 200', a3: 'A3 ERP', sap: 'SAP', quipu: 'Quipu', anfix: 'Anfix', contasol: 'ContaSol', excel_none: 'Excel / Cap', other: 'Altres' },
      pain: { manual_entry_time: 'Massa temps en entrada manual', pricing_errors: 'Errors de preus a les factures', duplicate_payments: 'Pagaments duplicats', audit_compliance: 'Auditoria / compliment', growth_scaling: 'Escalar l’equip d’AP', fraud_risk: 'Risc de frau de proveïdor' },
    },
  },
  validation: { required: 'Obligatori', email: 'Email no vàlid', minLength: 'Mínim {n} caràcters', phone: 'Telèfon no vàlid' },
  langSelector: { label: 'Idioma', es: 'Español', en: 'English', ca: 'Català' },
};
